<template>
  <div class="setting">
    <el-header>
      <div class="page-title">{{ pageTitle }}</div>
    </el-header>
    <el-main>
      <el-header>
        <div class="account-header">账号信息</div>
      </el-header>
      <el-main class="acocunt-main">
        <el-form ref="userForm" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="个人姓名" prop="name">
            <el-input v-model="form.name" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="账号">
            <el-input v-model="form.account" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="form.gender" disabled>
              <!-- <el-radio :label="0">保密</el-radio> -->
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="学校">
            <el-select v-model="form.school_name" placeholder="请选择学校" size="small" disabled>
              <el-option label="学校一" value="shanghai"></el-option>
              <el-option label="学校二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" size="small"></el-input>
          </el-form-item> -->
          <el-form-item label="最近登录">
            <el-input v-model="form.last_login_time" size="small" disabled></el-input>
          </el-form-item>
          <el-form-item label="个人头像">
            <el-upload class="avatar-uploader" name="avatar" :action="uploadAvatarUrl" :data="uploadAvatarParams" :headers="uploadAvatarHeader" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="form.image_url" :src="form.image_url" :onerror="default_thumbnail_img" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="人脸图片">
            <el-upload class="face-uploader" name="face_image" :action="uploadFaceUrl" :data="uploadAvatarParams" :headers="uploadAvatarHeader" :show-file-list="false" :on-success="handleFaceSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="form.face_url" :src="form.face_url" :onerror="default_face_img" class="face">
              <i v-else class="el-icon-plus face-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="生日" prop="birthday">
            <el-date-picker size="small" v-model="form.birthday" type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="身高" prop="height">
            <el-input-number v-model="form.height" size="small" :min="1" label="单位：cm"></el-input-number> cm
          </el-form-item>
          <el-form-item label="体重" prop="weight">
            <el-input-number v-model="form.weight" size="small" :min="1" label="单位：kg"></el-input-number> kg
          </el-form-item>
          <!-- <el-form-item label="个性签名" prop="user_sign">
            <el-input type="textarea" v-model="form.user_sign"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="onSubmit" size="medium">保存</el-button>
            <!-- <el-button @click="resetForm" size="medium">重置</el-button> -->
          </el-form-item>
        </el-form>
      </el-main>
      <el-container>
        <el-main>
          <el-header>
            <div class="setting-header">安全设置</div>
          </el-header>
          <el-main class="setting-main">
            <div class="pwd">
              <img src="~@/common/icon/setting/pwd@2x.png" alt="">
              <div class="text">
                <span>登录密码</span>
                <span class="func-text" @click="showPwdDialog">修改密码</span>
              </div>
            </div>
            <!-- <div class="phone-number">
              <div class="phone-img">
                <img src="~@/common/icon/setting/phone@2x.png" alt="">
              </div>
              <div class="text">
                <span>{{this.form.phone_bind === 1 ? '已绑定手机' : '未绑定手机'}}</span>
                <span class="func-text" @click="showPhoneNumberDialog">{{this.form.phone_bind === 1 ? this.form.phone_number : '绑定号码'}}</span>
              </div>
            </div> -->
          </el-main>
        </el-main>
        <!-- <el-main>
          <el-header>
            <div class="setting-header">第三方账号绑定</div>
          </el-header>
          <el-main class="setting-main">
            <div class="wechat-bind">
              <div class="wx-img">
                <img src="~@/common/icon/setting/wx@2x.png" alt="">
              </div>
              <div class="text">
                <span>微信（{{form.wechat_name?form.wechat_name:"微信名"}}）</span>
                <span class="func-text" @click="getWeixinCode">{{ form.wechat_bind==1?"已绑定":"现在绑定" }}</span>
              </div>
            </div>
          </el-main>
        </el-main> -->
      </el-container>
    </el-main>
    <el-dialog title="修改密码" :visible.sync="dialogPwd" v-if="dialogPwd" :close-on-click-modal="false" width="350px">
      <el-form :model="passwordForm" :rules="rules" ref="passwordForm" style="text-align:left;" label-width="80px">
        <el-form-item label="旧密码" prop="old_password">
          <el-input type="password" v-model="passwordForm.old_password" placeholder="请填写旧密码" style="width:90%;" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_password">
          <el-input type="password" v-model="passwordForm.new_password" placeholder="请填写新密码" style="width:90%;" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_again_password">
          <el-input type="password" v-model="passwordForm.new_again_password" placeholder="请再次填写新密码" style="width:90%;" size="small" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="updatePwd">确定</el-button>
        <el-button size="small" @click="dialogPwd=false">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定手机" :visible.sync="dialogPhoneNumber" :before-close="hiddenPhoneNumberDialog" :close-on-click-modal="false" width="350px">
      <el-form label-width="80px" style="margin-top:20px;">
        <el-form-item label="手机号">
          <el-input v-model="phone_number" placeholder="请填写手机号" style="width:90%;" size="small" clearable></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <el-input v-model="verify_code" placeholder="请填写验证码" style="width:90%;" size="small" clearable></el-input>
          <el-button class="get-verify-code" size="small" @click="getVerifyCode">获取验证码</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="bindPhoneNumber">确定</el-button>
        <el-button size="small" @click="hiddenPhoneNumberDialog">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定微信" :visible.sync="dialogWechat" :before-close="closeCode" :close-on-click-modal="false" width="240px">
      <div style="font-size:12px;color:#6c7d8f;margin-bottom:10px;">微信扫码关注公众号完成绑定</div>
      <div class="code-box">
        <img :src="imgUrl" alt="图片加载失败">
        <div class="overdue" v-show="showOverdue">二维码已过期，<span style="cursor:pointer;color:#559af8;" @click="getWeixinCode">刷新</span></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import sha1 from 'sha1'
import { getStorage, setStorage } from '@/common/js/localstorage'
import { isUrl, isPhone, isEmpty } from '@/common/js/reg'
import Api from '@/api/user'
import baseApi from '@/api/base'

export default {
  name: 'Setting',
  data() {
    return {
      pageTitle: '个人设置',
      uploadAvatarParams: {
        user_id: getStorage('user').id
      },
      uploadAvatarHeader: {
        Authorization: 'Bearer ' + getStorage('user').token
      },
      uploadAvatarUrl: `${window.baseUrl}/user/upload_avatar`,
      uploadFaceUrl: `${window.baseUrl}/ai_class/ai_origin_face_base/upload_image`,
      default_thumbnail_img: 'this.src="' + require("@/common/img/user_img.png") + '"',
      default_face_img: 'this.src="' + require("@/common/img/face_img.png") + '"',
      form: {
        name: getStorage('user').name,
        gender: getStorage('user').gender,
        school_id: getStorage('user').org_id,
        school_name: getStorage('user').org_name,
        email: getStorage('user').email,
        account: getStorage('user').account,
        last_login_time: getStorage('user').last_login_time,
        image_url: isUrl(getStorage('user').image_url) ? getStorage('user').image_url : window.staticsHost + getStorage('user').image_url,
        face_url: isUrl(getStorage('user').face_url) ? getStorage('user').face_url : window.staticsHost + getStorage('user').face_url,
        image_preview_url: 'http://gitlab.hison.net/uploads/-/system/user/avatar/41/avatar.png?width=40',
        user_sign: getStorage('user').user_sign,
        phone_bind: getStorage('user').phone_bind,
        phone_number: getStorage('user').phone_number,
        wechat_bind: getStorage('user').wechat_bind,
        wechat_name: getStorage('user').wechat_name,
        birthday: getStorage('user').birthday,
        height: getStorage('user').height,
        weight: getStorage('user').weight,
      },
      rules: {
        name: [
          { required: false, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        email: [
          { required: false, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        user_sign: [
          { max: 30, message: '最多可输入30个字符', trigger: 'blur' }
        ],
        old_password: [
          { required: true, message: "请输入旧密码", trigger: "blur" }
        ],
        new_password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: this.validatePassword1, trigger: "blur" },
        ],
        new_again_password: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: this.validatePassword2, trigger: "blur" },
        ],
      },
      //修改密码相关变量
      passwordForm: {
        old_password: '',
        new_password: '',
        new_again_password: ''
      },
      dialogPwd: false,
      //绑定手机相关变量
      phone_number: '',
      verify_code: '',
      dialogPhoneNumber: false,
      dialogWechat: false,
      showOverdue: false,// 二维码过期
      intervalId: null,// 计时器
      imgUrl: "",// 二维码路径
      sceneId: "",// 场景id
      expireSeconds: 0,// 二维码过期时间
      calcSecond: 0// 二维码生效时间
    }
  },
  destroyed() {
    // 在页面销毁后，清除计时器setStoragcon
    this.clear();
  },
  methods: {
    validatePassword1(rule, value, callback) {
      if (this.passwordForm.new_password.trim() == "") {
        callback(new Error("请先输入新密码"));
      } else {
        let check = /(^.*(?=.{9})(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*()_+[\]{}|;:'",./<>?-]).*$)|(^.*(?=.{8,20})(?=.*\d)(?=.*[a-z])(?=.*\d)(?=.*[A-Z]).*$)|(^.*(?=.{8,20})(?=.*\d)(?=.*[a-z])(?=.*[~!@#$%^&*()_+[\]{}|;:'",./<>?-]).*$)|(^.*(?=.{8,20})(?=.*\d)(?=.*[A-Z])(?=.*[~!@#$%^&*()_+[\]{}|;:'",./<>?-]).*$)|(^.*(?=.{8,20})(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*()_+[\]{}|;:'",./<>?-]).*$)/;
        if (check.test(this.passwordForm.new_password)) {
          callback();
        } else {
          callback("密码必须大于等于9位，且包含大、小写字母、特殊符号、数字至少3种");
        }
      }
    },
    validatePassword2(rule, value, callback) {
      if (this.passwordForm.new_password.trim() == "") {
        callback(new Error("请先输入新密码"));
      } else if (value.trim() != this.passwordForm.new_password.trim()) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    },
    onSubmit() {
      let params = {
        birthday: this.form.birthday,
        height: this.form.height,
        weight: this.form.weight
      }
      Api.updateUser(getStorage("user").id, params).then(response => {
        if (response.data.status === 0) {
          this.$message.success('修改成功');
          let obj = getStorage("user");
          obj.birthday = params.birthday;
          obj.height = params.height;
          obj.weight = params.weight;
          setStorage("user", obj);
        } else {
          this.$message.error(response.data.info.detail);
        }
      }).catch(() => { })
    },
    resetForm() {
      this.$refs.userForm.resetFields()
    },
    handleAvatarSuccess(res, file) {
      this.form.image_preview_url = URL.createObjectURL(file.raw)
      if (res.status === 0) {
        this.form.image_url = isUrl(res.data.avatar) ? res.data.avatar : window.staticsHost + res.data.avatar
        //修改本地storage
        let user = getStorage('user')
        user.image_url = res.data.avatar
        setStorage('user', user)
        this.$bus.$emit('checkLoginStatus')
      } else {
        this.$message.warning(res.info.detail)
      }
    },
    handleFaceSuccess(res, file) {
      console.log(res)
      this.form.image_preview_url = URL.createObjectURL(file.raw)
      console.log(this.form.image_preview_url)
      if (res.status === 0) {
        this.form.face_url = isUrl(res.data.face_url) ? res.data.face_url : window.staticsHost + res.data.face_url
        //修改本地storage
        let user = getStorage('user')
        user.face_url = res.data.face_url
        setStorage('user', user)
        this.$bus.$emit('checkLoginStatus')
      } else {
        this.$message.warning(res.info.detail)
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 和 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //展示修改密码弹框
    showPwdDialog() {
      this.passwordForm.old_password = ''
      this.passwordForm.new_password = ''
      this.passwordForm.new_again_password = ''
      this.dialogPwd = true
    },
    //展示绑定手机弹框
    showPhoneNumberDialog() {
      // if(this.form.phone_bind === 1){
      //   this.$message.info('已绑定手机')
      //   return
      // }
      this.dialogPhoneNumber = true
    },
    //隐藏绑定手机弹框
    hiddenPhoneNumberDialog() {
      this.dialogPhoneNumber = false
      this.phone_number = ''
      this.verify_code = ''
    },
    //修改密码
    updatePwd() {
      //先进行输入验证
      // if (this.old_password.trim().length === 0 || this.new_password.trim().length === 0 || this.new_again_password.trim().length === 0) {
      //   this.$message.warning('请输入密码')
      //   return
      // }
      // if (this.old_password.trim().length < 6 || this.new_password.trim().length < 6 || this.new_again_password.trim().length < 6) {
      //   this.$message.warning('密码不能少于6位')
      //   return
      // }
      // if (this.new_password.trim() !== this.new_again_password.trim()) {
      //   this.$message.warning('两次输入密码不一致')
      //   return
      // }
      // let reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*_-`])[\da-zA-Z~!@#$%^&*_-`]{6,}$/;
      // if (!reg.test(this.new_password)) {
      //   this.$message.warning('密码必须包括字母、数字、英文字符')
      //   return
      // }
      this.$refs["passwordForm"].validate((valid) => {
        if (valid) {
          const data = {
            old_pwd: sha1(this.passwordForm.old_password),
            new_pwd: sha1(this.passwordForm.new_password)
          }
          Api.resetPwd(data).then(response => {
            if (response.data.status === 0) {
              this.$message.success('修改密码成功')
              this.dialogPwd = false
            } else {
              this.$message.warning(response.data.info.detail)
            }
          }).catch(error => {
            console.log(error)
            this.$message.error('服务器开小差了')
          })
        } else {
          this.$message({
            type: "warning",
            message: "操作失败",
          });
        }
      });
    },
    //绑定手机
    bindPhoneNumber() {
      //先进行格式验证
      if (!isPhone(this.phone_number)) {
        this.$message.warning('请输入正确的手机号')
        return
      }
      if (isEmpty(this.verify_code)) {
        this.$message.warning('验证码不能为空')
        return
      }

      let data = {
        phone: this.phone_number,
        security_code: this.verify_code
      }
      Api.bindPhone(data).then(response => {
        if (response.data.status === 0) {
          this.$message.success('绑定手机成功')
          this.dialogPhoneNumber = false
        } else {
          this.$message.warning(response.data.info.detail)
        }
      }).catch(() => {
        this.verify_code = ''
        this.$message.error('服务器开小差了')
      })
    },
    //获取手机验证码
    getVerifyCode() {
      //先进行格式验证
      if (!isPhone(this.phone_number)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      let data = {
        phone_number: this.phone_number
      }
      Api.getVerifyCode(data).then(response => {
        if (response.data.status === 0) {
          this.$message.success('已发送手机验证码，请留意手机短信')
        } else {
          this.$message.warning(response.data.info.detail)
        }
      }).catch(() => {
        this.$message.error('服务器开小差了')
      })
    },
    // 获取微信二维码
    getWeixinCode() {
      baseApi.getWeixinCode({ type: 3 }).then((response) => {
        if (response.data.status == 0 && response.data.data) {
          this.showOverdue = false;
          this.calcSecond = 0;
          this.imgUrl = response.data.data.qrcode;
          this.sceneId = response.data.data.scene_id;
          this.expireSeconds = response.data.data.expire_seconds;
          if (!this.dialogWechat) {
            this.dialogWechat = true;
          }
          // 计时器正在进行中，退出函数
          if (this.intervalId != null) {
            return;
          } else {
            // 计时器为空，操作
            this.intervalId = setInterval(() => {
              this.calcSecond++;
              if (this.calcSecond >= this.expireSeconds) {
                // 二维码过期
                this.showOverdue = true;
                this.clear();
              } else {
                this.getWeChatScan();
              }
            }, 1000);
          }
        } else {
          this.$message({
            type: "error",
            message: response.data.info.detail
          });
        }
      });
    },
    // 清除计时器
    clear() {
      clearInterval(this.intervalId); // 清除计时器
      this.intervalId = null; // 设置为null
    },
    // 微信扫码登录
    getWeChatScan() {
      let params = {
        scene_id: this.sceneId
      }
      baseApi.getWeChatScan(params).then((response) => {
        if (response.data.status == 0 && response.data.data) {
          this.form.wechat_name = response.data.data.wechat_name;
          this.form.wechat_bind = response.data.data.wechat_bind;
          this.clear();
          this.$message({
            duration: 5000,
            type: "success",
            message: "成功绑定"
          });
          setTimeout(() => {
            this.dialogWechat = false;
          }, 1000);
        }
      });
    },
    // 关闭二维码弹窗
    closeCode() {
      this.clear();
      this.dialogWechat = false;
    }
  }
}
</script>

<style scoped lang="stylus">
.setting {
  .el-header {
    height: 40px !important;
    padding: 0 5px;

    .page-title {
      font-size: 18px;
      text-align: left;
      border-left: 4px solid #559af8;
      color: #515151;
      padding-left: 10px;
    }
  }

  .el-main {
    padding: 10px 0 0;

    // background-color #009688
    .el-header {
      height: 30px !important;

      .account-header, .setting-header {
        font-size: 16px;
        text-align: left;
        border-left: 3px solid #009688;
        color: #515151;
        padding-left: 10px;
      }
    }

    .el-main {
      max-height: 400px;
      overflow-y: hidden;

      // background-color #009688
      .el-form {
        width: calc(((100% - 300px) / 2));
        height: 400px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
      }

      /deep/ .el-form-item__content {
        text-align: left;
        margin-right: 50px;

        .avatar-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          border-radius: 50%;
        }

        .avatar-uploader .el-upload:hover {
          border-color: #409EFF;
        }

        .avatar-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 80px;
          height: 80px;
          line-height: 80px;
          text-align: center;
        }

        .avatar {
          width: 80px;
          height: 80px;
          display: block;
          border-radius: 50%;
        }

        .face-uploader .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }

        .face-uploader .el-upload:hover {
          border-color: #409EFF;
        }

        .face-uploader-icon {
          font-size: 28px;
          color: #8c939d;
          width: 180px;
          height: 220px;
          line-height: 80px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .face {
          width: 180px;
          height: 220px;
          display: block;
        }
      }
    }

    .el-container {
      display: flex;
      justify-content: flex-start;

      .el-main {
        .setting-main {
          // background-color #009688
          display: flex;

          .pwd, .phone-number, .wechat-bind {
            display: flex;
            margin: 0 50px;

            img {
              height: 60px;
              width: 60px;
              border-radius: 50%;
              margin: 20px 15px;
            }

            .phone-img, .wx-img {
              height: 60px;
              width: 60px;
              border-radius: 50%;
              margin: 20px 15px;
              background-color: #559AF8;

              img {
                border-radius: 0;
                margin: 15px;
                height: 30px;
                width: 20px;
              }
            }

            .wx-img {
              height: 60px;
              width: 60px;
              border-radius: 50%;
              margin: 20px 15px;
              background-color: #559AF8;

              img {
                border-radius: 0;
                margin: 20px 15px;
                height: 20px;
                width: 25px;
              }
            }

            .text {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: center;
              color: #333333;

              span {
                display: block;
                margin: 2px 0;
              }

              .func-text {
                color: #559AF8;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .el-dialog {
    border-radius: 15px !important;

    .get-verify-code {
      position: absolute;
      top: 5px;
      right: 10px;
      // background-color #009688
    }
  }

  .code-box {
    border: 1px solid #e9edf2;
    border-radius: 8px;
    position: relative;
    overflow: hidden;

    img {
      width: 200px;
      height: 200px;
    }

    .overdue {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(255, 255, 255, 0.95);
      font-size: 14px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  /deep/ .el-dialog__body {
    padding: 0 20px 20px;
  }
}
</style>